<h6 *ngIf="label" class="title u-h6 u-anthracite">{{ label | translate }}</h6>
<ng-content></ng-content>
<p class="error-msg" *ngIf="hasError && showErrorMsg">
  <i class="app-icon-alert" *ngIf="showIcon"></i>
  {{ errorMsg | translate : errorTranslateParam }}
</p>
